import React from 'react'
import { createUseStyles } from 'react-jss'

import BarLoader from 'react-spinners/BarLoader'

const useStyles = createUseStyles({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    alignItems: 'center'
  }
})

function Loading() {
  const styles = useStyles()
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <img width="100%" alt="TOPTIC GO" src={require('../../assets/logo.png')} />
        <BarLoader color='#00BDFF' width="100%" />
      </div>
    </div>
  )
}

export default Loading
